type Props = {
  children: React.ReactNode;
};

export function PublicRouteContainer({ children }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#001f3f' }}>
      <div className="w-full max-w-md bg-white p-10 rounded-2xl shadow-2xl flex flex-col items-center">
        {children}
      </div>
    </div>
  );
}
